const states = {
  Dubai: 'Dubai',
  'Abu Dhabi': 'Abu Dhabi',
  Ajman: 'Ajman',
  Fujayrah: 'Fujayrah',
  'Ras al-Khaymah': 'Ras al-Khaymah',
  Sharjah: 'Sharjah',
  'Umm al-Qaywayn': 'Umm al-Qaywayn'
};

const stateOptions = [];
for (const key of Object.keys(states)) {
  stateOptions.push({ value: key, name: states[key] });
}

exports.countryDefinition = {
  country: 'United Arab Emirates',
  code: 'AE',
  schema: {
    company: { label: 'Company' },
    address: { label: 'Address' },
    address2: { label: 'Address 2' },
    stateCode: { type: 'array', array: stateOptions, label: 'Emirate' }
  },
  states,
  viewFormat: [['company'], ['address'], ['address2'], ['stateCode']],
  formFormat: [['company'], ['address'], ['address2'], ['stateCode']],
  requiredFormFields: [{ field: 'address' }, { field: 'stateCode' }]
};
